export { default } from './usePreviousProps';


//////////////////
// WEBPACK FOOTER
// ../@mui/utils/esm/usePreviousProps/index.js
// module id = 754
// module chunks = 22